import { render, staticRenderFns } from "./GetMessagesStatisticsOperators.vue?vue&type=template&id=049891b6&"
import script from "./GetMessagesStatisticsOperators.vue?vue&type=script&lang=js&"
export * from "./GetMessagesStatisticsOperators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports